<div>
  <h1>404 Not Found!</h1>
  <p>Something went wrong, please hit the <a href="#" (click)="goBack()">back button</a>, or check the url you entered.</p>
</div>
